namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_mbutton, {
		
		backgroundColor: '#23387B' as any,
		borderRadius: '10px',
		padding: 0,
		outlineOffset: '4px',
		
		Front: {
			// padding: '16px 16px' as any,
			justify: {
				content: 'center'
			},
			align: {
				items: 'center',
			},
			width: '4rem',
			height: '3.8rem',
			padding: '0.4rem',
			borderRadius: '10px' as any,
			font: {
				'size': '1.25rem',
			},
			background: '#4A5DAC',
			color: 'white',
			transform: 'translateY(-6px)',
		} as any,

		// '[mol_check_checked]': {
		// 	true: {
		// 		outline: '2px solid var(--mol_theme_current)',
		// 		outlineOffset: '2px',
		// 	},
		// },
		
	} )
	
}
